import React from 'react'
import style from './style.module.less'
import store from '../store'

export default [
  {
    title: '位置',
    dataIndex: 'user',
    key: 'user',
    render: (text, record) => <div>{record.seat}</div>
  },
  {
    title: '图片',
    dataIndex: 'photo',
    key: 'photo',
    render: (text, { image_info }) => (
      <div className={style.imgBox}>
        <dl
          style={{
            display: image_info ? 'block' : 'none'
          }}
        >
          <dt>
            {image_info
              ? image_info.posters &&
                image_info.posters.map((item, index) => {
                  const { show_type } = image_info
                  let props = {}

                  if (show_type == 1) {
                    // 双图
                    props = {
                      width: '73',
                      height: '79'
                    }
                  } else if (show_type == 2) {
                    // 竖图
                    props = {
                      width: '96',
                      height: '109'
                    }
                  } else {
                    // 横图
                    props = {
                      width: '116',
                      height: '72'
                    }
                  }

                  return <img {...props} src={item.image_path} key={index} />
                })
              : ''}
          </dt>
        </dl>
      </div>
    )
  },
  {
    title: '跳转结果',
    dataIndex: 'time',
    key: 'time',
    render: (text, record) => (
      <div
        className={style.jump}
        style={{
          padding:
            record.image_info &&
            record.image_info.posters &&
            record.image_info.posters.length == 1
              ? '50px 0'
              : '0'
        }}
      >
        {record.image_info
          ? record.image_info.posters &&
            record.image_info.posters.map((item, index) => (
              <div key={index}>
                <dl
                  className={style.setMealInfo}
                  style={{ display: item.target_type == 15 ? 'block' : 'none' }}
                >
                  <dt>
                    <img
                      src={
                        item.entity
                          ? item.entity.cover_path + '?imageView2/1/w/100/h/62'
                          : ''
                      }
                    />
                  </dt>
                  <dd>
                    <p>{item.entity ? item.entity.title : ''}</p>
                    <p>
                      <em>{item.entity ? item.entity.show_price : ''}</em>
                      <i className="hlj-gray1">
                        {item.entity ? item.entity.market_price : ''}
                      </i>
                    </p>
                  </dd>
                </dl>
                <dl
                  style={{ display: item.target_type == 99 ? 'block' : 'none' }}
                >
                  <a>私信</a>
                </dl>
              </div>
            ))
          : ''}
      </div>
    )
  },
  {
    title: '操作',
    dataIndex: 'look',
    key: 'look',
    render: (text, record) => (
      <div>
        <a
          onClick={store.linkToFn(record.id, record.seat, record.image_info)}
          className="hlj-blue1"
          style={{ marginRight: 12, color: '#508cee' }}
        >
          编辑
        </a>
        <a
          onClick={store.upSeatFn(record.id)}
          className="hlj-blue1"
          style={{
            marginRight: 12,
            color: '#508cee',
            display: record.seat == 1 ? 'none' : 'inline-block'
          }}
        >
          上移
        </a>
        <a
          onClick={store.deleteShowCaseFn(record.id)}
          className="hlj-red1"
          style={{ color: '#ff5c5c', display: record.id ? 'inline' : 'none' }}
        >
          删除
        </a>
      </div>
    )
  }
]
